<template>
    <div class="" style="">
        <div class="topImgContent">
        <div class="topImgTitleContent">
          <div class="topImgTitle">园区动态</div>
          <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
          <div class="e-flex menuContent">
              <img class="ic_home" src="@/assets/images/ic_home.png">
              <div class="pointer" @click="goMainPage()">首页</div>
              <div>/</div>
              <div class="pointer" @click="$router.push({ path: (from && from == 1) ? '/index/index' : '/parkDynamics/index', query: {}})">园区动态</div>
              <div>/</div>
              <div>正文</div>
            </div>
        </div>
      </div>
      <div class="pd_newsDetailContent e-flex">
        <div class="pd_newsDetailWhiteContent">
            <div class="pd_detailTitleContent">
                <div class="pd_detailTitle">{{ info ? info.title : '' }}</div>
                <div class="pd_detailSubTitle">{{info ? (info.origin + ' ' + info.publishDate.slice(0,10).replace('-','年').replace('-','月') + "日 " + info.publishDate.slice(11,16)) : ''}}</div>
            </div>
            <div class="pd_newsCommonContent" v-html="info ? info.content : ''"></div>
        </div>
      </div>
      <div class="pd_paginationNewsContent e-flex">
        <div class="pd_paginationWhiteContent">
            <div class="changePageList e-flex" v-if="prevInfo" @click="changeList(prevInfo)">
              <img class="pageCHangeIcon" src="../../assets/images/ic_top.png">
              <div class="changePageLabel">上一篇</div>
              <div class="changePageCommon e-line-1">{{ prevInfo.title }}</div>
            </div>
            <div class="changePageList e-flex" v-if="nextInfo" @click="changeList(nextInfo)">
              <img class="pageCHangeIcon" src="../../assets/images/ic_down.png">
              <div class="changePageLabel">下一篇</div>
              <div class="changePageCommon e-line-1">{{ nextInfo.title }}</div>
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import '../../styles/parkDynamics.css'
    export default {
      name: 'parkDynamics',
      data () {
        return {
          from: '',
          id: '',
          info: null,
          lastNextList: [],
          prevInfo: null,
          nextInfo: null
        }
      },
      created() {
        this.from = this.$route.query.from
        this.id = this.$route.query.id
        this.getDetail()
        this.getLastNext()
      },
      methods: {
        goMainPage() {
          this.$emit('goNavPage', {
            key:'1',
            path: ['1'],
            pathId: '1'
          })
        },
        getDetail() {
          this.request({
            url: 'info/detail',
            method: 'POST',
            data: {
              id: this.id
            }
          }).then(res => {
            this.info = res.data
          })
        },
        getLastNext() {
          this.request({
            url: 'info/lastNext',
            method: 'POST',
            data: {
              id: this.id
            }
          }).then(res => {
            this.lastNextList = res.data
            this.lastNextList.forEach((item, index, array) => {
              if (item.id > this.id) {
                this.prevInfo = item
              } else {
                this.nextInfo = item
              }
            })
          })
        },
        changeList(item) {
          this.id = item.id
          this.prevInfo = null
          this.nextInfo = null
          this.getDetail()
          this.getLastNext()
        }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/parkDynamics/detail.vue